import { V2EventCreateRequestDtoCategory } from "@everon-it/api-client/contents-gw";
import { type FormikValues } from "formik";

type PreviewValiDateProps = {
    formikValues: FormikValues;
    pathname: string;
};

function isPreviewValiDate({ formikValues, pathname }: PreviewValiDateProps): boolean {
    const isEventPage = pathname.includes("event");
    const isNoticePage = pathname.includes("notice");
    const isChargerPage = pathname.includes("charger");
    const isChargingServicePage = pathname.includes("charging");

    const { title, content, urls, thumbnailUrl, displayStartAt, contentCategory } = formikValues;

    if (isEventPage) {
        if (contentCategory === V2EventCreateRequestDtoCategory.CONTENT) {
            return !!content;
        }

        if (contentCategory === V2EventCreateRequestDtoCategory.BUTTON) {
            return !!(content && urls?.length);
        }
    }

    if (isNoticePage) {
        return !!(content && title && displayStartAt);
    }

    if (isChargerPage) {
        return !!(content && title && thumbnailUrl);
    }

    if (isChargingServicePage) {
        return !!(content && title && thumbnailUrl);
    }

    return false;
}

export default isPreviewValiDate;
